export enum SyncType {
    LEARNER_EVENT = "'Learner event-edit'!A2:L",
    LEARNER = "'Thông tin HV'!A2:L",
    COURSE = 'ImportCourse!A3:Z',
    TEST_RESULTS_INTER_ABOVE = "'Inter+'!E4:AA",
    TEST_RESULTS_PRE = 'Pre!E4:AA',
    TEST_RESULTS_CE = 'CE!E4:X',
    MOODLE_USER = 'MOODLE_USER',
    MOODLE_COHORT = 'MOODLE_COHORT',
    MOODLE_GROUP_USER = 'MOODLE_GROUP_USER'
}

export const SYNC_TYPE_OPTIONS = [
    { label: SyncType.LEARNER_EVENT, value: SyncType.LEARNER_EVENT },
    { label: SyncType.LEARNER, value: SyncType.LEARNER },
    { label: SyncType.COURSE, value: SyncType.COURSE },
    {
        label: SyncType.TEST_RESULTS_INTER_ABOVE,
        value: SyncType.TEST_RESULTS_INTER_ABOVE
    },
    { label: SyncType.TEST_RESULTS_PRE, value: SyncType.TEST_RESULTS_PRE },
    { label: SyncType.TEST_RESULTS_CE, value: SyncType.TEST_RESULTS_CE },
    { label: SyncType.MOODLE_USER, value: SyncType.MOODLE_USER },
    { label: SyncType.MOODLE_COHORT, value: SyncType.MOODLE_COHORT },
    { label: SyncType.MOODLE_GROUP_USER, value: SyncType.MOODLE_GROUP_USER }
];
